import { getSocket } from 'src/creators/OpenReporting.creators';
import { getRandomId } from 'src/utils/commonFunctions';

export const onMessageSend = (
  reportId: string,
  text: string,
  session: string,
) => {
  getSocket(session).emit('chat', {
    token: session,
    channel: reportId,
    value: text,
    id: getRandomId(),
  });
};
